export default __webpack_public_path__ + "src/assets/icn-cant-access.63726b77984bd5bd74cdf119bb7d72fa.svg";